import { STORAGE_USER_KEY } from './constants'
import { reactLocalStorage } from 'reactjs-localstorage'
import { isEmpty } from 'lodash'

export function getCurrentUser() {
  const user = reactLocalStorage.getObject(STORAGE_USER_KEY)
  return isEmpty(user) ? null : user
}
